import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Content, Video } from '../../shared/models/content';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminService } from '../admin.service';
import { DatePipe } from '@angular/common';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { capitalizeStr } from '../../shared/filters/titlecase.pipe';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import * as _ from 'lodash';
import { TCCPLocalStorageService } from '../../shared/services/tccp-local-storage.service';
import { environment } from '../../../environments/environment';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-manage-videos',
  templateUrl: './manage-videos.component.html',
  styleUrls: ['./manage-videos.component.scss']
})
export class ManageVideosComponent implements OnInit {

  public displayedColumns: string[] = [];
  public videoDataSource = new MatTableDataSource([]);
  public contents: Content[];
  public videoGroup: any[];
  public hasPermission = false;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    private adminService: AdminService, public commonService: TCCPCommonService,
    private storageService: TCCPLocalStorageService, private dialog: MatDialog, private datePipe: DatePipe) {
    this.displayedColumns = ['videos.videoName', 'videos.videoGroup', 'featureType', 'uploadedTime', 'uploadedBy', 'edit', 'delete'];
  }

  ngOnInit() {
    this.getAllVideos();
    const upn = this.storageService.getUpn();
    // const roles = this.commonService.getAccessRole(upn);
    const roles: string[] = this.storageService.getRoles();
    const userAccess = this.commonService.getAccess('Videos', roles);
    const accessLevel = _.get(userAccess[0], 'accessLevel');
    if (accessLevel === 1) {
      this.hasPermission = true;
    } else {
      this.displayedColumns = ['videos.videoName', 'videos.videoGroup', 'featureType', 'uploadedTime', 'uploadedBy'];
    }
  }

  getAllVideos() {
    this.adminService.getAllVideos().subscribe((response: any) => {
      if (response) {
        let sortedContents = [];

        sortedContents = response.sort((obj1, obj2) =>
          obj1.videos.videoName > obj2.videos.videoName ? 1 : -1);


        this.videoGroup = response.map(x => x.videos.videoGroup);
        this.videoGroup = this.videoGroup.filter((n, i) => this.videoGroup.indexOf(n) === i).sort((a, b) => a > b ? 1 : -1);
        this.videoDataSource.data = sortedContents;

        setTimeout(() => {
          this.videoDataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
              case 'videos.videoName': return item.videos.videoName;
              case 'videos.videoGroup': return item.videos.videoGroup;

              default: return item[property];
            }
          };
          this.videoDataSource.sort = this.sort;
          this.videoDataSource.paginator = this.paginator;
        });
        this.videoDataSource.filterPredicate = (data: any, filter) => {
          const dataStr = JSON.stringify(data).toLowerCase();
          return dataStr.indexOf(filter) !== -1;
        };
      }
    });
  }

  addVideos() {
    const dialogRef = this.dialog.open(AddVideosDialogComponent, {
      width: '500px',
      data: { videoGroup: this.videoGroup, content: { videos: {} as Video } as Content }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAllVideos();
      }
    });

  }

  applyFilter(filterValue: string) {
    this.videoDataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteVideo(content: Content) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: 'Are you sure you want to delete the Video?',
      position: { top: '100px' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteContent(content.contentId);
      }
    });
  }

  deleteContent(id: string) {
    this.adminService.deleteContentById(id).subscribe(data => {
      this.getAllVideos();
    });
  }

  editVideo(content: Content) {
    const dialogRef = this.dialog.open(AddVideosDialogComponent, {
      width: '500px',
      data: { videoGroup: this.videoGroup, content },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAllVideos();
      }
    });
  }

}

@Component({
  selector: 'app-add-videos-dialog-component',
  templateUrl: './add-videos-dialog.component.html',
  styleUrls: ['../admin.component.scss', './manage-videos.component.scss']

})
export class AddVideosDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ManageVideosComponent>, private adminService: AdminService, private authService: MsalService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }
  public video: Video = {} as Video;
  public division: string;
  public featureType: string;
  public isSubmit = false;
  public content: Content = { videos: {} as Video } as Content;
  public Groups: [];
  public theme: string = null;

  ngOnInit() {
    this.theme = environment.applicationName + '-' + this.adminService.selectedApplication;
    this.division = this.adminService.selectedApplication.toUpperCase();
    if (this.data) {
      this.content = JSON.parse(JSON.stringify(this.data.content));
      this.Groups = this.data.videoGroup;
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  onSelect() {
    this.isSubmit = true;
    if (this.content.videos.videoName && this.content.videos.videoGroup && this.content.videos.videoUrl && this.content.featureType) {
      this.content.division = this.adminService.selectedApplication;
      this.content.contentType = 'video';
      this.content.uploadedTime = new Date(new Date().toUTCString());
      this.content.uploadedBy = this.authService.instance.getActiveAccount().username;
      if (!this.content.contentId) {
        this.adminService.insertdocument(this.content).subscribe((response: any) => {
          if (response) {
            this.dialogRef.close({ event: 'save' });
          }
        });
      } else {
        this.adminService.updateSupportContent(this.content).subscribe((response: any) => {
          if (response) {
            this.dialogRef.close({ event: 'save' });
          }
        });
      }
    }
  }

  onCancel() {
    this.dialogRef.close();
  }
}
